// JS-side mirror of brand colors from src/styles/v2/color/raw.scss
const BRAND_COLOR = {
  violet: '#933cc1', // $violet
  primaryDark: '#5f1486', // $c-primary-dark
  primaryDefault: '#821bb8', // $c-primary-default
  primaryMedium: '#af6dd1', // $c-primary-medium
  primaryLight: '#e3bff5', // $c-primary-light

  // Gradient shades derived from violet
  gradientDark: '#7b2fa8',
  gradientLight: '#b45ce0',
};

export default BRAND_COLOR;
